import {
	GET_BUY_DESTINATIONS_SUCCESS,
	CLEAR_BUY_DESTINATIONS,
} from 'stash/actions/api/buyDestinations';
import {
	GetBuyDestinationsSuccessAction,
	ClearBuyDestinationsAction,
} from 'stash/actions/api/buyDestinations';

function buyDestinationsReducer(
	state = [],
	action: GetBuyDestinationsSuccessAction | ClearBuyDestinationsAction
) {
	switch (action.type) {
		case GET_BUY_DESTINATIONS_SUCCESS:
			return action.response.destinations || state;
		case CLEAR_BUY_DESTINATIONS:
			return [];
		default:
			return state;
	}
}

export default buyDestinationsReducer;
